module.exports = __webpack_public_path__ + "media/dot.1f1208ea.wav";